export default __webpack_public_path__ + "static/media/middleware-stack.b10adab1.png";